module.exports = __webpack_public_path__ + "img/plan4_girl.c7d9a165.png";